import { Box, Flex, Text } from "@chakra-ui/react";
import React, { memo } from "react";

interface ProgressBarProps {
  currentStep: number;
  steps: Array<{ title: string }>;
}

export const ProgressBar: React.FC<ProgressBarProps> = memo(
  ({ currentStep, steps }) => {
    return (
      <Flex gap={2} mb={2} mt={4}>
        {steps.map((step, index) => (
          <Flex key={index} flex={1} direction="column" gap={2}>
            <Box
              height="4px"
              bg={
                index < currentStep
                  ? "#24954E"
                  : index === currentStep
                  ? "#28ABF7"
                  : "#D1D9E2"
              }
              borderRadius="full"
              transition="all 0.3s ease"
            />
            <Text
              fontSize="sm"
              fontWeight={400}
              color={index <= currentStep ? "#65819D" : "#B9C6D3"}
              transition="all 0.3s ease"
            >
              {step.title}
            </Text>
          </Flex>
        ))}
      </Flex>
    );
  }
);
